<div class="notification-container">
  <div 
    *ngFor="let notification of notifications" 
    class="notification notification-{{notification.type}}"
    [@slideIn]
  >
    <div class="notification-content">
      <mat-icon class="notification-icon">{{ getIcon(notification.type) }}</mat-icon>
      <span class="notification-message">{{ notification.message }}</span>
    </div>
    <button class="notification-close" (click)="close(notification.id)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
